const action = "FORECAST_TRIGGER";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';

export const triggerRequest = (payload) => {
    return {
        type: REQUEST,
        payload
    };
};
export const triggerSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const clearState = (response) => ({
  type: CLEAR
});

export const triggerFailure = (error) => ({
  type: FAILURE,
  payload: error
}); 